export default __webpack_public_path__ + "static/media/tasks-icon.5b36315f.svg";